export const site = {
  name: "拾真社",
  slogan: "只摆事实，讲依据",
  domain: "https://hdlyjgs.cn",
  email: "contact@shizhenshe.com",
  tipEmail: "tips@shizhenshe.com",
  intro:
    "拾真社是一个专注独家爆料求证的内容平台。我们把零散的爆料按档案方式整理，逐条列出原始材料、来源链与可信度评分，让读者在信息洪流里能自己看清事实。",
  stats: [
    { value: "3,180+", label: "已完成求证档案" },
    { value: "12,600+", label: "登记原始来源" },
    { value: "92%", label: "读者认可辨析结论" },
  ],
  principles: [
    {
      title: "先看材料，再看说法",
      desc: "任何爆料进入档案前，先登记原始材料。没有材料的说法，只会以线索形式记录，不会当作结论。",
      icon: "ri-file-search-line",
    },
    {
      title: "逐条对照，不做整体背书",
      desc: "一条爆料里可能同时有真有假。我们拆成最小事实单元逐条辨析，不因为一部分成立就全盘采信。",
      icon: "ri-list-check-2",
    },
    {
      title: "来源可追溯，结论可复核",
      desc: "每条结论后面都标注支撑材料与核验方式，读者可以沿着来源链自行复核，而不是只看一个分数。",
      icon: "ri-links-line",
    },
    {
      title: "不确定就说不确定",
      desc: "当关键来源缺失时，我们保持「待求证」，并在页面明确标出缺口，而不是用推测填满空白。",
      icon: "ri-question-line",
    },
  ],
  testimonials: [
    {
      name: "读者 · 周先生",
      role: "关注公共事件三年",
      text: "以前看到群里的截图只能凭感觉判断。现在会先来拾真社搜一下档案号，能看到原始材料和时间线，心里踏实很多。",
    },
    {
      name: "从业者 · 林女士",
      role: "品牌内容从业者",
      text: "他们把一个爆料拆成好几条最小事实来核对，这种拆解法很实用，我们内部做舆情判断时也会参考。",
    },
    {
      name: "读者 · 陈同学",
      role: "在校学生",
      text: "喜欢「待求证」这种写法。宁可说暂时没结论，也不硬给一个看上去很确定的答案。",
    },
  ],
};